import { Filter } from '../../helpers/filters';

export const getTradesToUpdate = (item, allTrades, selectedTrades) => {
  const isCurrentlyChecked = selectedTrades.some((v) => v.key === item.key);
  let addParentTrade = false;
  let parentTrade;
  if (item.level === 'specialty') {
    parentTrade = allTrades.find((t) => t.key === item.tradeKey);
    if (isCurrentlyChecked) {
      const specialties = parentTrade.specialties;
      const tradeSelectedSpecialties = specialties.filter((s) =>
        selectedTrades.some((t) => t.key === s.key)
      );
      const parentWasAutoChecked = selectedTrades.find(
        (t) => t.key === parentTrade.key
      )?.autoChecked;
      addParentTrade =
        parentWasAutoChecked &&
        tradeSelectedSpecialties.length === 1 &&
        tradeSelectedSpecialties[0].key === item.key;
    } else {
      addParentTrade =
        selectedTrades.find((t) => t.key === parentTrade.key) === undefined;
    }
  }
  const checked = !isCurrentlyChecked;
  return {
    checked,
    trades: [
      { ...item, autoChecked: undefined },
      ...(item.specialties ?? []),
      ...(addParentTrade
        ? [{ ...parentTrade, autoChecked: checked ? true : undefined }]
        : []),
    ],
  };
};

export const isIndeterminate = (
  item: Filter,
  sublistPropertyName,
  selectedFilters
) => {
  const doesNotHaveSublistItems =
    !sublistPropertyName || !item[sublistPropertyName]?.length;
  if (doesNotHaveSublistItems) {
    return false;
  }
  const allSublistItemsAreChecked = item[sublistPropertyName]?.every((si) =>
    selectedFilters.find((sf) => sf.key === si.key)
  );
  if (allSublistItemsAreChecked) {
    return false;
  }
  const someSublistItemsAreChecked = item[sublistPropertyName]?.some((si) =>
    selectedFilters.find((sf) => sf.key === si.key)
  );
  return !!someSublistItemsAreChecked;
};
